// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1m405","paramInput":"JobSimulator_paramInput__meqKG","input":"JobSimulator_input__2Ks4W"};